module.exports = __webpack_public_path__ + "static/img/top.35710112.png";